export default function R_Scatterplot() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Scatterplot Component</h1>
      <p>This is the R_Scatterplot tutorial section.</p>
    </div>
  );
}
